<div class="d-flex flex-row" style="cursor : pointer">
  <div class="d-flex flex-row align-items-center">
    <div class="d-flex flex-column mr-2">
      @if (entityAction.status == 'UNDER_PROCESSING') {
        <h4 class="mb-0">{{entityAction.action | formatEnum}} Under Processing</h4>
      }
      @if (entityAction.status == 'SUCCESS') {
        <h4 class="mb-0">{{entityAction.action | formatEnum}} Completed Successfully</h4>
      }
      @if (entityAction.status == 'FAILURE') {
        <h4 class="mb-0">{{entityAction.action | formatEnum}} Failed</h4>
      }
      @if (entityAction.status == 'UNDER_PROCESSING') {
        <p>Your background task named {{entityAction.name}} is being processed!!!</p>
      }
      @if (entityAction.status == 'SUCCESS') {
        <p>Your background task named {{entityAction.name}} completed Successfully</p>
      }
      @if (entityAction.status == 'FAILURE') {
        <p>Your background task named {{entityAction.name}} has failed</p>
      }
    </div>
    <div class="d-flex flex-row flex-fill">
      <button class="ml-auto" (click)="closeEntityActionSnackBar()">Okay!!</button>
      @if (entityAction.action == 'GENERATE_REPORT' && entityAction.status == 'SUCCESS') {
        <button class="ml-auto" (click)="viewExportedData()">View File</button>
      }
    </div>
  </div>
</div>